import { CursorEffect } from "@/components/ui/cursor-effect/CursorEffect";
import Hero from "@/components/features/hero/Hero";
import About from "@/components/features/about/About";
import { Trust } from "@/components/features/trust";
import Skills from "@/components/features/skills/Skills";
import Projects from "@/components/features/projects/Projects";
import Contact from "@/components/features/contact/Contact";
import { Newsletter } from "@/components/shared/newsletter/Newsletter";
import { SEO, generateFAQSchema } from "@/components/shared/seo";
import { useTranslation } from "@/context/TranslationContext";

export function App() {
  const { language, t } = useTranslation();

  // FAQ Schema für die Startseite
  const faqSchema = generateFAQSchema([
    {
      question:
        language === "de"
          ? "Welche Dienstleistungen bietet KoriCode an?"
          : "What services does KoriCode offer?",
      answer:
        language === "de"
          ? "KoriCode bietet Fullstack-Entwicklung für Web-Apps, Mobile Apps (iOS), Cloud & DevOps Lösungen sowie SEO-Optimierung an."
          : "KoriCode offers fullstack development for web apps, mobile apps (iOS), cloud & DevOps solutions, and SEO optimization.",
    },
    {
      question:
        language === "de"
          ? "Wo ist KoriCode ansässig?"
          : "Where is KoriCode located?",
      answer:
        language === "de"
          ? "KoriCode ist in München, Deutschland ansässig und bietet Dienstleistungen für Kunden in ganz Deutschland und international an."
          : "KoriCode is based in Munich, Germany, and provides services to clients throughout Germany and internationally.",
    },
    {
      question:
        language === "de"
          ? "Welche Technologien verwendet KoriCode?"
          : "What technologies does KoriCode use?",
      answer:
        language === "de"
          ? "KoriCode arbeitet mit modernen Technologien wie React, Angular, Node.js, TypeScript, Firebase, AWS, GCP und mehr."
          : "KoriCode works with modern technologies including React, Angular, Node.js, TypeScript, Firebase, AWS, GCP, and more.",
    },
  ]);

  return (
    <main>
      <SEO
        title={
          language === "de"
            ? "Maßgeschneiderte Software-Entwicklung in München"
            : "Tailored Software Development in Munich"
        }
        description={
          language === "de"
            ? "Professionelle Fullstack-Entwicklung für Web-Apps, Mobile Apps und Cloud-Lösungen. Von der Idee bis zur Live-Schaltung – Ihr IT-Partner in München."
            : "Professional fullstack development for web apps, mobile apps, and cloud solutions. From idea to launch – your IT partner in Munich."
        }
        keywords={
          language === "de"
            ? "Webentwicklung, Software-Entwicklung, Fullstack, React, Angular, Mobile Apps, Cloud, DevOps, München, Freelancer"
            : "web development, software development, fullstack, React, Angular, mobile apps, cloud, DevOps, Munich, freelancer"
        }
        canonicalUrl="/"
        language={language}
        structuredData={faqSchema}
      />
      <CursorEffect />
      <Hero />
      {/* <About /> */}
      <Trust />
      <Skills />
      {/* <Projects /> */}
      <Contact />
      <Newsletter />
    </main>
  );
}
